/**
 * @desc 库存冻结记录
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.stockFreezeRecord.pageList.Params, options?: any) {
  return updateResponse(
    http(URL + `/stockFreezeRecord/pageList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
